// 设置Local Storage

// 设置Local Storage
export function  settoken(token){
    return localStorage.setItem('token',token)
}


//获取Local Storage
export function gettoken(token){
    return localStorage.getItem('token')
}

// 删除Local Storage

export function removetoken(token){
    return localStorage.removeItem("token")
}


// 设置登录
export function  setlogin(login){
    return localStorage.setItem('login',login)
}


// 获取登录信息

export function  getlogin(login){
    return localStorage.getItem('login',login)
}



// 删除登录信息

export function  dellogin(login){
    return localStorage.removeItem('login',login)
}
